const translations = {
  "en": {
    "View Details": "View Details"
  },
  "zh-tw": {
    "View Details": "查看詳情"
  }
};

export default translations;
